<template>
  <div class="footprint">
    <div class="choose-state">
      <span
        v-for="(choose,index) in chooses"
        :key="choose.name"
        :class="chooNum==index?'choosed':''"
        @click="active(index)"
      >{{choose.name}}</span>
    </div>
    <div class="template-box">
      <!-- <div class="template-time">2019</div> -->
      <div class="template-list">
        <!--  @click="goDetail(news.newsId)" -->
        <div
          class="news-template"
          v-for="news in sevenLine"
          :key="news.imgUrl"
         
        >
          <div class="news-left">
            <img :src="news.imgUrl" alt v-if="news.imgUrl==null?false:true" />
          </div>
          <div class="news-right">
            <p>{{news.title}}</p>
            <!-- <p>
              <span style="margin-right:.5rem;">浏览:{{news.sees}}</span>
              <span>点赞:{{news.praise}}</span>
              <span style="margin-right:.3rem;float:right">{{news.times|times}}</span>
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [{ name: "我的信息足迹" }, { name: "我的视频足迹" }],
      chooNum: 0,
      sevenLine: [],
      page: 1,
      fours: [
        {
          time: "2019",
          msg: [
            {
              imgUrl: require("@/assets/boutique/dp-jy-sy16.png"),
              title: "平“语”近人",
              source: "共产党员网·2018.02.03"
            },
            {
              imgUrl: require("@/assets/boutique/dp-jy-sy17.png"),
              title: "听学新思想",
              source: "共产党员网·2018.02.03"
            }
          ]
        },
        {
          time: "2018",
          msg: [
            {
              imgUrl: require("@/assets/boutique/dp-jy-sy16.png"),
              title: "平“语”近人",
              source: "共产党员网·2018.02.03"
            },
            {
              imgUrl: require("@/assets/boutique/dp-jy-sy17.png"),
              title: "听学新思想",
              source: "共产党员网·2018.02.03"
            }
          ]
        }
      ],
      url: "/api/Personal/Footprint",
      typename: "信息"
    };
  },
  methods: {
    active(index) {
      this.chooNum = index;
      switch (index) {
        case 0:
          this.typename = "信息"
          break;
        case 1:
          this.typename = "视频"
          break;

      }
      this.getMsg()
    },
    goDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "新闻动态", id: newsid, dbnum: 0 }
      });
    },
    goDetailV() {
      this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放" }
      });
    },
    getMsg() {
      this.axios
        .post(this.url, {
          typename: this.typename,
          title: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          this.sevenLine = [];
          if (e.data.code == 0) {
            this.sevenLine = e.data.msg;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted: function() {
    this.getMsg();
  }
};
</script>

<style lang="scss" scoped>
.footprint {
  .video-template {
    .class-box {
      .class-template {
        &:nth-child(odd) {
          margin-right: 2%;
        }
        img {
          width: 100%;
        }
        p {
          &:nth-child(3) {
            color: #999999;
          }
          line-height: 2;
          padding: 0 0.2rem;
          font-size: 0.26rem;
        }
        width: 49%;
        background: #fff;
        margin-top: 0.3rem;
      }
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      padding: 0 0.2rem;
    }
    margin-top: 0.2rem;
  }
  .template-box {
    .template-list {
      .news-template {
        width: 94%;
        margin: 0 auto;
        display: flex;
        margin-bottom: 0.2rem;
        background: #fff;
        padding: 0.2rem 0;
        //   align-items: center;
        .news-right {
          width: 100%;
          margin-left: 0.2rem;
          p:nth-child(1) {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            margin-bottom: 0.3rem;
            line-height: 1.8;
          }
          p:nth-child(2) {
            border-top: 0.01rem solid #e6e6e6;
            padding-top: 0.2rem;
            color: #999999;
            font-size: 0.26rem;
          }
        }
        .news-left {
          img {
            width: 2.4rem;
            height: 2rem;
          }
        }
      }
      margin-top: 0.3rem;
      // background: #fff;
    }
    margin-top: 0.2rem;
  }
  .template-time {
    padding: 0 0.2rem;
    background: #fff;
    line-height: 2;
    margin-top: 0.2rem;
  }
  .choose-state {
    .choosed {
      &::before {
        position: absolute;
        width: 20%;
        height: 0.08rem;
        left: 40%;
        background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
          linear-gradient(#ae1717, #ae1717);
        border-radius: 0.08rem;
        content: "";
        bottom: 0;
      }
      position: relative;
      font-weight: bold;
      color: #000;
    }
    span {
      display: inline-block;
      width: 50%;
      text-align: center;
      color: #999999;
    }
    background: #fff;
    line-height: 3;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>

